import { FC, useEffect } from 'react';

interface IProps {
    children?: any,
    [key: string]: any,
}

export const MetaTitle: FC<IProps> = ({children}) => {
    useEffect(() => {
        if (children) {
            document.title = `${children} - Digital Service Portal`;
        }

        return () => {
            document.title = `Digital Service Portal`;
        };
    }, [children]);

    return null;
}